import * as Amount from "../amount"
import { AType, summon } from "@silversea-ssc/functional-support"
import { PaxPriceDetails } from "./pax-price-details"
import * as F from "fp-ts/function"
import * as RONEA from "fp-ts/ReadonlyNonEmptyArray"

export const _PaxPrice = summon((F) =>
    F.interface(
        {
            number: F.number(),
            total: Amount.Amount(F),
            details: PaxPriceDetails(F),
        },
        "PaxPrice",
    ),
)
export type PaxPrice = AType<typeof _PaxPrice>

const total = _PaxPrice.lensFromProp("total")

export const PaxPrice = /* @__PURE__ */ Object.assign(_PaxPrice, {
    total,
    sum: F.flow(RONEA.map(total.get), RONEA.concatAll(Amount.SemigroupSum)),
})
